import { put, select, takeLatest } from 'redux-saga/effects';

import * as authProvider from 'data-providers/authProvider';

import { GET_ACTIVE_DEALER, UPDATE_ACTIVE_DEALER } from './constants';

function* getActiveDealer() {
  try {
    const { dealer: dealerId } = yield select((store) => {
      return store.user;
    });

    const activeDealer = yield authProvider.getDealer(dealerId);

    yield put({ type: UPDATE_ACTIVE_DEALER, payload: activeDealer });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    throw error;
  }
}

export function* watchGetActiveDealer() {
  yield takeLatest(GET_ACTIVE_DEALER, getActiveDealer);
}
